import {useGenericFilters} from 'app/hooks';
import {useAsyncActions} from 'app/utils/redux';

import {convertLocationParamsToFetchParams} from './api';
import {selectTemplateFilters, setTemplateFilters} from './slice';

import type {TemplateFetchParams} from './types';
import type {Location} from 'history';
import type {InjectedRouter} from 'react-router/lib/Router';
export function useTemplateFilters(
  location: Location<TemplateFetchParams>,
  router: InjectedRouter
) {
  return useGenericFilters(
    location,
    router,
    selectTemplateFilters,
    useAsyncActions({
      setTemplateFilters,
    }).setTemplateFilters,
    convertLocationParamsToFetchParams
  );
}
